import type { ReactNode } from 'react'
import { BrowserRouter as ReactRouterBrowserRouter } from 'react-router-dom'
import { createBrowserHistory } from 'history'

import pathnames from './config/pathnames'

const history = createBrowserHistory()

export function redirect404() {
  history.replace(pathnames.notFound)
}

type Props = {
  children: ReactNode
}

function BrowserRouter({ children }: Props) {
  return <ReactRouterBrowserRouter>{children}</ReactRouterBrowserRouter>
}

export { BrowserRouter }
